import React, { useEffect, useState } from "react";
import Flex from "../../../../structure/Flex";
import Input from "../Input";
import RadioButtons from "../RadioButtons";

type SelectOrTextValue = { selected: any; text: string };

interface SelectOrTextProps {
  options?: Array<{ id: any; value: string; hint?: any }>;
  value: SelectOrTextValue;
  name: string;
  setValue: React.Dispatch<SelectOrTextValue>;
  placeholder?: string;
}

const SelectOrText: React.FC<SelectOrTextProps> = ({
  options = [],
  value,
  setValue,
  name,
  placeholder = "Enter your own",
}) => {
  const [selected, setSelected] = useState<any>(() =>
    value.text ? "-1" : value.selected || ""
  );
  const [text, setText] = useState(() => value.text || "");

  useEffect(() => {
    selected === "-1" || selected === ""
      ? setValue({ selected: "", text })
      : setValue({ selected, text: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, text]);

  return (
    <Flex className="p-2 w-full" justify="between" items="center">
      <RadioButtons
        name={`${name}-options-select`}
        value={selected}
        setValue={setSelected}
        options={[...options, { id: "-1", value: "Other" }]}
      />
      {selected === "-1" && (
        <>
          <span className="mx-6">or</span>
          <span className="flex-grow">
            <Input
              type="text"
              name={`${name}-custom-text`}
              placeholder={placeholder}
              value={text}
              setValue={setText}
            />
          </span>
        </>
      )}
    </Flex>
  );
};

export default SelectOrText;
